import React from "react";
import "./experience.css";
import ExperienceCard from "./ExperienceCard";

const Experience = () => {
  return (
    <section id="experience">
      <h5>My Current Skills</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <ExperienceCard title="HTML" level="Expert" />
          <ExperienceCard title="CSS" level="Expert" />
          <ExperienceCard title="Javascript" level="Expert" />
          <ExperienceCard title="ReactJS" level="Expert" />
          <ExperienceCard title="VueJS" level="Expert" />
          <ExperienceCard title="TailwindCSS" level="Expert" />
          <ExperienceCard title="Bootstrap" level="Expert" />
          <ExperienceCard title="SASS/SCSS" level="Expert" />
          <ExperienceCard title="Vuex" level="Expert" />
          <ExperienceCard title="Redux" level="Expert" />
          <ExperienceCard title="MaterialUI" level="Expert" />
          <ExperienceCard title="NextJS" level="Expert" />
          <ExperienceCard title="AngularJS" level="Expert" />
        </div>
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <ExperienceCard title="NodeJS" level="Expert" />
          <ExperienceCard title="ExpressJS" level="Expert" />
          <ExperienceCard title="DjangoDB" level="Expert" />
          <ExperienceCard title="NoSQL" level="Expert" />
          <ExperienceCard title="MySQL" level="Expert" />
          <ExperienceCard title="MongoDB" level="Expert" />
          <ExperienceCard title="Python" level="Intermediate" />
          <ExperienceCard title="PHP" level="Intermediate" />
          <ExperienceCard title=".NET" level="Intermediate" />
        </div>

        <div className="experience__gamedev">
          <h3>Game Development</h3>
          <ExperienceCard title="Unity" level="Expert" />
          <ExperienceCard title="Unreal Engine 4" level="Expert" />
          <ExperienceCard title="Unreal Engine 5" level="Intermediate" />
        </div>
        <div className="experience__cloudservices">
          <h3>Cloud Services</h3>
          <ExperienceCard title="AWS" level="Intermediate" />
          <ExperienceCard title="Sendgrid" level="Expert" />
        </div>
        <div className="experience__qa">
          <h3>Quality Assurance</h3>
          <ExperienceCard title="CypressJS" level="Expert" />
          <ExperienceCard title="Advanced Unit Testing" level="Expert" />
          <ExperienceCard title="Integration Testing" level="Expert" />
          <ExperienceCard title="Functional Testing" level="Expert" />
          <ExperienceCard title="Whitebox Testing" level="Expert" />
          <ExperienceCard title="Blackbox Testing" level="Expert" />
        </div>
      </div>
    </section>
  );
};

export default Experience;
